<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-card v-if="!loading&&best" flat>
            <v-card-title class="accent white--text title">
                {{ title | translate }}
            </v-card-title>
            <v-card-text>
                <v-layout row>
                    <v-flex v-for="(value,key) in best">
                        <value-box  :white-mode="whiteMode" :value="value" unit="" :title="key|translate"></value-box>
                    </v-flex>
                </v-layout>
                <vue-plotly v-if="plot1" :data="plot1.data" :white-mode="whiteMode"
                            :layout="plot1.layout" :options="{}"/>
                <vue-plotly v-if="plot2" :data="plot2.data" :white-mode="whiteMode"
                            :layout="plot2.layout" :options="{}"/>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {callAPI} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import VuePlotly from "../VuePlotly";
import ValueBox from "../ValueBox";

export default {
    props: {
        title: {type: String, default: "Sensor calibration"},
        conf: {type: Array, default: null},
        dateRange: {type: Object, default: null},
        whiteMode: {type: Boolean, default: false},
    },
    components: {ValueBox, LoadingProgressBar,VuePlotly},
    name: 'SensorCalibrationWidget',
    watch: {
        dateRange() {
            this.refresh()
        },
    },

    data: function () {
        return {
            loading: false,
            timeout: null,
            best: null,
            plot1: null,
            plot2: null,
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.getData, 500);
        },
        async getData() {
            if (this.conf&&this.conf.length>0){
                this.loading = true
                this.best = null
                this.plot1 = null
                this.plot2 = null
                let result= await callAPI('sensor-calibration/',{
                    date_range:[this.dateRange.start,this.dateRange.end],
                    conf:this.conf
                })
                console.log(result)
                delete(result.data.best.alpha)
                this.best=result.data.best
                delete(result.data.path.alpha)
                this.plot1 = {
                    "data": Object.keys(result.data.path).map(key=>{return{
                        name:key,
                        x:result.data.criterion.index,
                        y:result.data.path[key],
                    }}),
                    "layout": {
                        title: "Path",
                        "height": 300,
                        "margin": {
                            "l": 50,
                            "r": 50,
                            "t": 50,
                            "pad": 1
                        },
                        yaxis: {
                            title: '',
                        },
                        xaxis: {
                            title: '',
                            nticks:result.data.criterion.index.length+1
                        },
                        legend: {
                            orientation: 'h',
                            traceorder:'normal',
                            y:-0.3
                        },

                    }
                }
                this.plot2 = {
                    "data": [{
                        name:"Criterion",
                        x:result.data.criterion.index,
                        y:result.data.criterion.criterion,
                    }],
                    "layout": {
                        title: "Criterion",
                        "height": 300,
                        "margin": {
                            "l": 50,
                            "r": 50,
                            "t": 50,
                            "pad": 1
                        },
                        yaxis: {
                            title: '',
                        },
                        xaxis: {
                            title: '',
                            nticks:result.data.criterion.index.length+1
                        },
                    }
                }
                this.loading = false
            }
        }
    },
}
</script>

<style scoped>

</style>
